import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import "chartjs-plugin-crosshair";
import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart } from 'chart.js';
import { useStock } from "../../StockContext";

Chart.register(annotationPlugin);

function DashboardCard05() {
  const { stockSelected1 } = useStock();
  const [chartData, setChartData] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(null);
  const [targetHighPrice, setTargetHighPrice] = useState(0);
  const [targetLowPrice, setTargetLowPrice] = useState(0);
  const [targetMeanPrice, setTargetMeanPrice] = useState(0);
  const [currency, setCurrency] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!stockSelected1?.symbol) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const [priceRes, historicalRes, financialRes] = await Promise.all([
          fetch(`https://investorverden.onrender.com/api/stock-price?q=${stockSelected1.symbol}`),
          fetch(`https://investorverden.onrender.com/api/historical?q=${stockSelected1.symbol}&range=1m&interval=1d`),
          fetch(`https://investorverden.onrender.com/api/financials?q=${stockSelected1.symbol}`)
        ]);

        const priceData = await priceRes.json();
        const historicalData = await historicalRes.json();
        const financialData = await financialRes.json();

        setCurrentPrice(priceData.currentPrice);
        setCurrency(financialData.summaryDetail?.currency || "USD");

        if (financialData.financialData) {
          setTargetHighPrice(financialData.financialData.targetHighPrice || 0);
          setTargetLowPrice(financialData.financialData.targetLowPrice || 0);
          setTargetMeanPrice(financialData.financialData.targetMeanPrice || 0);
        }

        const prices = historicalData.stockData.map(item => item.close);
        const labels = historicalData.stockData.map(item => 
          new Date(item.date).toISOString().split('T')[0]
        );

        setChartData({
          labels,
          datasets: [
            {
              label: "Aktiekurs",
              data: prices,
              fill: true,
              backgroundColor: "rgba(0, 123, 255, 0.2)",
              borderColor: "rgba(0, 123, 255, 1)",
              borderWidth: 2,
              pointRadius: 0,
              pointHoverRadius: 0,
              tension: 0.4,
            }
          ]
        });

      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [stockSelected1]);

  if (loading) return <div>Loader...</div>;
  if (error) return <div>Fejl: {error}</div>;

  return (
    <div className="flex flex-col col-span-full sm:col-span-6 bg-white dark:bg-gray-800 shadow-lg rounded-xl p-4">
      <div className="px-5 pt-5">
        <header className="flex justify-between items-start mb-2">
          <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2">
            {stockSelected1?.symbol || 'Select a Stock'} 12 måneders kursmål
          </h2>
        </header>
        <div className="text-3xl font-bold text-gray-800 dark:text-gray-100">
          {currentPrice} {currency}
        </div>
      </div>

      <div className="px-5 pt-5 flex-grow">
        <div style={{ position: "relative", height: "300px" }}>
          {chartData && (
            <Line
              data={chartData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
               // Inside the Line component options
scales: {
  x: { 
    grid: { display: false },
    ticks: { display: false },
    border: { display: true }
  },
  y: { 
    beginAtZero: false,
    grid: { display: false },
    position: 'right'
  }
},
                plugins: {
                  legend: { display: false },
                  tooltip: {
                    mode: "index",
                    intersect: false,
                    callbacks: {
                      label: function(context) {
                        return `${context.dataset.label}: ${currency} ${context.parsed.y.toFixed(2)}`;
                      }
                    }
                  },
                  annotation: {
                    annotations: {
                      targetHigh: {
                        type: 'line',
                        yMin: targetHighPrice,
                        yMax: targetHighPrice,
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderDash: [5, 5],
                        borderWidth: 2,
                        label: {
                          display: true,
                          content: `${currency} ${targetHighPrice}`,
                          position: 'end'
                        }
                      },
                      targetMean: {
                        type: 'line',
                        yMin: targetMeanPrice,
                        yMax: targetMeanPrice,
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderDash: [5, 5],
                        borderWidth: 2,
                        label: {
                          display: true,
                          content: `${currency} ${targetMeanPrice}`,
                          position: 'end'
                        }
                      },
                      targetLow: {
                        type: 'line',
                        yMin: targetLowPrice,
                        yMax: targetLowPrice,
                        borderColor: 'rgba(255, 159, 64, 1)',
                        borderDash: [5, 5],
                        borderWidth: 2,
                        label: {
                          display: true,
                          content: `${currency} ${targetLowPrice}`,
                          position: 'end'
                        }
                      }
                    }
                  },
                  crosshair: {
                    line: {
                      color: "#000",
                      width: 1,
                      dashPattern: [6, 4]
                    }
                  }
                },
                interaction: {
                  mode: "index",
                  intersect: false
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardCard05;